import React from 'react';

import { CloseDownIcon } from '$/images/FontAwesomeIcons';
import { css } from '@emotion/react';
import isMobile from '$/utils/isMobile';
import { DragControls } from 'framer-motion';

export const DragOrCloseHandle: React.FC<{
  dragControls?: DragControls;
  onClose: () => void;
  className?: string;
  color?: string;
}> = React.memo(({ onClose, className, dragControls, color = '#ffffff' }) => {
  const startDrag = React.useCallback(
    (e) => {
      dragControls?.start(e);
    },
    [dragControls]
  );

  const useDragBar = isMobile && dragControls;

  return (
    <div
      className={className}
      id='CloseOrDragHandle'
      css={css`
        display: flex;
        items-align: center;
        justify-content: center;
        width: 100%;
        cursor: pointer;
        margin-top: 0;
        ${useDragBar ? 'height: 0.15rem;' : ''}
        touch-action: none;
      `}
      onClick={onClose}
      onTouchStart={startDrag}
      onPointerDown={startDrag}
    >
      {useDragBar ? (
        <div
          className='flex rounded-full w-full'
          css={css`
            border-color: ${color};
            max-width: 200px;
            margin-top: 6px;
            border-width: 2px;
          `}
        />
      ) : (
        <CloseDownIcon
          className='mx-auto'
          css={css`
            color: ${color};
            height: 1.5rem;
          `}
        />
      )}
    </div>
  );
});
